/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  $(".table-scroll-container").on("scroll", function (e) {
    if (
      e.currentTarget.scrollLeft > 50 ||
      e.currentTarget.scrollLeft ===
        e.currentTarget.scrollWidth - e.currentTarget.clientWidth
    ) {
      $(this).parents($(".caption").addClass("is-scrolled"));
    } else {
      $(this).parents($(".caption").removeClass("is-scrolled"));
    }
  });
});
